export const DOCTYPES = {
  TOP_QUERIES: 'TOP_SEARCH_QUERIES',
  KEYWORD: 'KEYWORD_SUGGESTION',
  PROMOTED: 'PROMOTED_SUGGESTION',
  POPULAR_PRODUCTS: 'POPULAR_PRODUCTS',
};
export const DOCTYPES_LIST = [DOCTYPES.TOP_QUERIES, DOCTYPES.KEYWORD, DOCTYPES.PROMOTED];
export const DOCTYPE_SCORE = {
  TOP_SEARCH_QUERIES: 2,
  KEYWORD_SUGGESTION: 1,
  PROMOTED_SUGGESTION: 3,
};
